import { render, staticRenderFns } from "./Snack.vue?vue&type=template&id=77d740c4&scoped=true"
import script from "./Snack.vue?vue&type=script&lang=ts"
export * from "./Snack.vue?vue&type=script&lang=ts"
import style0 from "./Snack.vue?vue&type=style&index=0&id=77d740c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d740c4",
  null
  
)

export default component.exports